import {take, call, put, fork, takeLatest} from 'redux-saga/effects'
import {delay} from 'redux-saga'
import {getCategoriesWithUncategorized} from 'sagas/api/category'
import {
  LIBRARY_ITEM_LIST_ITEM_REQUEST,
  LIBRARY_ITEM_LIST_CATEGORY_WITH_UNCATEGORIZED_REQUEST,
  LIBRARY_ITEM_PAGE_REQUEST,
  LIBRARY_ITEM_SET_FILTER_ITEM,
  LIBRARY_ITEM_ON_CHANGE_OUTLET_IDS,
  LIBRARY_ITEM_ITEM_LIST_EXPORT,
  LIBRARY_ITEM_ITEM_LIST_TEMPLATE,
  LIBRARY_ITEM_ON_CLICK_CREATE_ITEM,
  LIBRARY_ITEM_ON_CLICK_ROW,
  LIBRARY_ITEM_ON_CLICK_CANCEL,
  LIBRARY_ITEM_ON_CLICK_BTN_ITEM_VARIANT,
  LIBRARY_ITEM_ON_CANCEL_ITEM_VARIANT_MODAL,
  LIBRARY_ITEM_ON_CONFIRM_ITEM_VARIANT_MODAL,
  LIBRARY_ITEM_ON_CLICK_BTN_ITEM_TRACKING,
  LIBRARY_ITEM_ON_CLICK_BTN_COGS_TRACKING,
  LIBRARY_ITEM_ON_CANCEL_ITEM_INVENTORY_ALERT_MODAL,
  LIBRARY_ITEM_ON_CANCEL_COGS_MODAL,
  LIBRARY_ITEM_ON_CONFIRM_ITEM_INVENTORY_ALERT_MODAL,
  LIBRARY_ITEM_ON_CONFIRM_COGS_MODAL,
  LIBRARY_ITEM_FILL_FORM_DETAIL_ITEM,
  LIBRARY_ITEM_SUBMIT_FORM_UPDATE,
  LIBRARY_ITEM_SUBMIT_FORM_CREATE,
  LIBRARY_ITEM_DELETE_ITEM,
  LIBRARY_ITEM_ON_CLICK_CREATE_NEW_CATEGORY,
  LIBRARY_ITEM_CONFIRM_CREATE_NEW_CATEGORY,
  LIBRARY_ITEM_CANCEL_CREATE_NEW_CATEGORY,
  LIBRARY_ITEM_ON_SUCCESS_IMPORT
} from 'actions/library/item/constants'
import * as apiOutlets from 'api/outlets'
import * as actItem from 'actions/library/item'
import * as apiProfile from 'api/profile'
import * as apiCategory from 'api/categories'
import {initialize, arrayRemoveAll, arrayPush, reset, change} from 'redux-form'
import * as act from 'actions'
import * as actNotif from 'actions/notifications'
import * as apiItem from 'api/libraries/items'
import * as actGetExportedFile from 'actions/get-exported-file'
import * as apiModifier from 'api/modifiers'
import * as apiTax from 'api/taxes'
import {setSelectedOutletIds} from 'actions/actionBar'
import {showPageLoadingSpinner} from 'actions/loadingSpinner'
import * as mpLibItem from 'mixpanel/library/list'

/****************************************
 * API Request saga
 ****************************************/

function * fillForm (item) {
  yield put(initialize('search', {
    categoryId: item.categoryId,
    typeInventoryId: item.typeInventoryId,
    search: item.search
  }))
}

export function * fillFormDetail (request) {
  const {payload: {formatFormDetail}} = request
  yield put(initialize('item', {
    id: formatFormDetail.id,
    name: formatFormDetail.name,
    itemVariant: formatFormDetail.itemVariant,
    itemInventory: formatFormDetail.itemInventory,
    description: formatFormDetail.description,
    modifierIds: formatFormDetail.modifierIds,
    itemInventoryIds: formatFormDetail.itemInventoryIds
  }))
}

export function * fetchSummary (params) {
  yield put(act.showProgressBar())
  try {
    let response = yield call(apiItem.getSummary, params)
    return response.data
  } catch (error) {
    yield put(actNotif.error(error.message))
    return false
  } finally {
    yield put(act.hideProgressBar())
  }
}

function * setFilterItem (request) {
  yield put(actItem.setItems([]))
  yield put(showPageLoadingSpinner(true))
  const {payload: {categoryId, typeInventoryId, keyword}} = request
  yield put(actItem.setFilterState(categoryId, typeInventoryId, keyword))
  yield put(act.showProgressBar())
  try {
    yield call(itemsRequest, {page: 1, categoryId, typeInventoryId, keyword})
    yield put(actItem.itemSummaryRequest({categoryId, typeInventoryId, keyword}))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
  }
}

function * fillSearch (profile) {
  let assignedOutletIds = []
  if (profile.outlet_id.length > 1) {
    assignedOutletIds = [profile.outlet_id[0]]
  } else {
    assignedOutletIds = profile.outlet_id
  }
  let data = {'outletIds': assignedOutletIds}
  yield put(initialize('search', data))
}

export function * onChangeOutletIds (request) {
  yield put(actItem.closeRightColumn())
  yield put(actItem.setItems([]))
  yield put(actItem.setItemSummary([]))
  yield put(showPageLoadingSpinner(true))
  const {payload: {outletIds}} = request
  try {
    yield put(act.showProgressBar())
    yield call(apiOutlets.patchLogin, {id: outletIds})
    let resProfile = yield call(apiProfile.getProfile)
    yield put(setSelectedOutletIds(outletIds))
    yield put(change('search', 'outletIds', outletIds))
    yield put(actItem.unSetFilterState())
    yield call(fillForm, {categoryId: 0, typeInventoryId: 0, search: ''})
    yield call(fillSearch, resProfile.data)
    yield put(actItem.listCategoryWithUncategorizedRequest())
    yield call(itemsRequest, {page: 1, categoryId: 0, typeInventoryId: 0, keyword: ''})
    yield put(actItem.itemSummaryRequest({}))
    let modifierRes = yield call(apiModifier.getModifiersV1)
    yield put(actItem.setModifiers(modifierRes.data))
    let taxRes = yield call(apiTax.getTaxes)
    yield put(actItem.setTaxes(taxRes.data.results))
    mpLibItem.libraryItemChangeFilter({
      outletIds,
      category: 0,
      inventory: 0
    })
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(showPageLoadingSpinner(false))
  }
}

/**
 * Listen for page request of itemlibrary. This just works like wrapper
 */
export function * pageRequestFlow () {
  yield put(showPageLoadingSpinner(true))
  yield put(actItem.setItems([]))
  yield put(actItem.setItemSummary([]))
  yield put(actItem.setItemDetail(null))
  yield put(actItem.closeRightColumn())
  yield put(reset('item'))
  yield put(act.showProgressBar())
  try {
    yield call(fillForm, {categoryId: 0, typeInventoryId: 0, search: ''})
    yield call(itemsRequest, {page: 1, categoryId: 0, typeInventoryId: 0, keyword: ''})
    let response = yield call(apiOutlets.outlets)
    yield put(actItem.setOutlets(response.data))
    let resProfile = yield call(apiProfile.getProfile)
    let modifierRes = yield call(apiModifier.getModifiersV1)
    let taxRes = yield call(apiTax.getTaxes)
    yield put(actItem.setTaxes(taxRes.data.results)) // because API return for tax is slightly different from modifier
    yield put(actItem.setModifiers(modifierRes.data))
    yield call(fillSearch, resProfile.data)
    yield put(actItem.listCategoryWithUncategorizedRequest())
    yield put(actItem.itemSummaryRequest({}))
    mpLibItem.libraryItemStart({
      outletIds: [resProfile.data.outlet_id[0]],
      category: 0,
      inventory: 0
    })
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(showPageLoadingSpinner(false))
  }
}

export function * getItems (params) {
  yield put(act.showProgressBar())
  try {
    let response = yield call(apiItem.getItems, params)
    return response.data
  } catch (error) {
    // If we get an error we send Redux the appropiate action and return
    yield put(actNotif.error(error.message))
    return false
  } finally {
    yield put(act.hideProgressBar())
    yield put(showPageLoadingSpinner(false))
  }
}

export function * itemsRequest (request) {
  let categoryId, typeInventoryId, keyword, page, previousItems, items
  if (request.payload) {
    let requestPayload = request.payload.query
    let filterState = requestPayload.filterState
    previousItems = request.payload.previousItems
    categoryId = filterState.categoryId
    typeInventoryId = filterState.typeInventoryId
    keyword = filterState.keyword
    page = requestPayload.page
  } else {
    categoryId = request.categoryId
    typeInventoryId = request.typeInventoryId
    keyword = request.keyword
    page = request.page
  }
  let query = {
    page: page,
    category_id: !parseInt(categoryId) ? '' : categoryId,
    inventory: !parseInt(typeInventoryId) ? 'all' : (typeInventoryId === '1' ? 'low' : 'out'),
    keyword: !keyword ? '' : keyword
  }

  yield put(act.showProgressBar())

  try {
    let itemsResponse = yield call(getItems, query)
    if (previousItems) {
      items = previousItems.concat(itemsResponse)
    } else {
      items = itemsResponse
    }
    yield put(actItem.setItems(items)) // todo refactor
    if (page <= 1) {
      let summary = yield call(fetchSummary, query) // todo refactor
      yield put(actItem.setItemSummary(summary))
      yield put(actItem.setTotalPage(summary.total_pages))
    }
    yield put(actItem.setCurrentPage(page))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
  }
  yield put(showPageLoadingSpinner(false))
}

/**
 * Listen for listen category request
 * It will fetch category data from the server and set the category state with action
 */
export function * getCategoriesWithUncategorizedFlow () {
  while (true) {
    yield take(LIBRARY_ITEM_LIST_CATEGORY_WITH_UNCATEGORIZED_REQUEST)
    let categories = yield call(getCategoriesWithUncategorized)
    if (categories) {
      yield put(actItem.setCategories(categories))
    }
  }
}

export function * getExportItem (request) {
  let {payload: {prefix}} = request
  yield put(act.showLoadingSpinner(true))
  try {
    let response = yield call(apiItem.getExportItem)
    let responseData = response.data
    if (responseData.message === 'ok') {
      yield put(actGetExportedFile.getExportedWithoutOutlet(prefix))
    } else {
      yield put(actNotif.error(responseData.message))
    }
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.showLoadingSpinner(false))
  }
}

export function * downloadItemsTemplate (request) {
  let {payload: {prefix}} = request
  yield put(act.showLoadingSpinner(true))
  try {
    let response = yield call(apiItem.getItemTemplate)
    let responseData = response.data
    if (responseData.message === 'ok') {
      yield put(actGetExportedFile.getExportedWithoutOutlet(prefix))
    } else {
      yield put(actNotif.error(responseData.message))
    }
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.showLoadingSpinner(false))
  }
}

export function * clickCreateItem () {
  yield put(actItem.onClickCancel()) // do cancel first
  yield put(act.showProgressBar())
  try {
    let response = yield call(apiItem.getNewItem)
    let responseData = response.data
    responseData.active_modifiers = []
    responseData.taxes = []
    responseData.item_variants.map(function (iv) {
      iv.price = iv.price || iv.price === 0 ? iv.price.toString() : iv.price
      iv.is_editable = !iv.is_saved
      iv.saved_cogs = !(iv.cogs === null && !iv.track_cogs)
      return iv
    })
    if (responseData.item_variants.length < 1) {
      responseData.item_variants.push({
        name: '',
        price: null,
        sku: '',
        in_stock: 0,
        stock_alert: 0,
        cogs: null,
        saved_cogs: false,
        is_saved: false,
        is_editable: true,
        is_new: true
      })
    }
    yield put(actItem.setItemDetail(responseData))
    yield put(actItem.setMustScrollTop(true))
    yield call(openRightColumn)
    yield put(initialize('item', responseData))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(actItem.setMustScrollTop(false))
  }
}

function * openRightColumn () {
  yield put(actItem.openRightColumn())
}

function * closeRightColumn () {
  yield put(actItem.closeRightColumn())
}

export function * clickCancel () {
  yield put(actItem.setItemDetail(null))
  yield put(reset('item'))
  yield call(closeRightColumn)
}

export function * clickItemRow (request) {
  let {payload: {item}} = request
  try {
    yield put(reset('item'))
    yield put(actItem.setItemDetail(null))
    yield put(act.showProgressBar())

    const itemDetailRes = yield call(apiItem.getItemById, item.id)
    const {data: itemDetail} = itemDetailRes
    yield put(actItem.setItemDetail(itemDetail))
    // change price to string to handle redux form isDirty
    itemDetail.item_variants.map(function (iv) {
      iv.price = iv.price || iv.price === 0 ? iv.price.toString() : iv.price
      iv.is_editable = !iv.is_saved
      iv.saved_cogs = !(iv.cogs === null && !iv.track_cogs)
      return iv
    })
    yield put(initialize('item', {...itemDetail}))
    yield put(actItem.setMustScrollTop(true))
    yield call(openRightColumn)
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(actItem.setMustScrollTop(false))
  }
}

export function * onClickBtnItemVariant (request) {
  const {payload: {itemForm}} = request
  yield put(actItem.showItemVariantModal())
  yield put(initialize('modal_item_variants', itemForm))
  yield put(actItem.setPreviousItemForm(itemForm))
}

export function * onCancelItemVariantModal (request) {
  yield put(initialize('modal_item_variants', {}))
  yield put(actItem.hideItemVariantModal())
}

export function * onConfirmItemVariantModal (request) {
  const {value} = request.payload
  yield put(arrayRemoveAll('item', 'item_variants'))
  for (let idx = 0; idx < value.item_variants.length; idx++) {
    yield put(arrayPush('item', 'item_variants', value.item_variants[idx]))
  }
  yield put(initialize('modal_item_variants', {}))
  yield put(actItem.hideItemVariantModal())
}

export function * onClickBtnItemTracking (request) {
  let {payload: {itemForm, isTrack}} = request
  yield put(actItem.showItemInventoryAleryModal())
  yield put(actItem.setPreviousItemForm(itemForm))
  let thereIsNew = false
  const itemVariantsWithTracking = itemForm.item_variants.map((iv) => {
    if (iv.is_new || !isTrack) {
      thereIsNew = true
      return {
        ...iv,
        track_stock: true,
        stock_alert: iv.stock_alert ? iv.stock_alert : '0',
        alert: true,
        in_stock: iv.in_stock ? iv.in_stock : '0',
        is_new: false
      }
    } else {
      return {...iv}
    }
  })
  // HACKY CODE
  // hack ini untuk mengakai hack yang dilakukan pada file yang sebelumnya pada saat solve FD-1471,
  // inti hack ini mencegah dirtyform jika tidak ada perubahan pada form item ketika confirm nanti, dan perlunya dirty pada saat ada iv baru
  // is_new akan true jika item variant baru terbentuk, dan akan false ketika ia di track
  if (thereIsNew) {
    yield put(initialize('modal_item_variants', {...itemForm, item_variants: []}))
    for (let idx = 0; idx < itemVariantsWithTracking.length; idx++) {
      yield put(arrayPush('modal_item_variants', 'item_variants', itemVariantsWithTracking[idx]))
    }
  } else {
    const newItem = {...itemForm, item_variants: itemVariantsWithTracking}
    yield put(initialize('modal_item_variants', newItem))
  }
}

export function * onClickBtnCOGSTracking (request) {
  let {payload: {itemForm, isTrack}} = request
  yield put(actItem.showCOGSModal(isTrack))
  yield put(actItem.setPreviousItemForm(itemForm))
  if (!isTrack) {
    const itemVariantsWithTracking = itemForm.item_variants.map((iv) => {
      if (!itemForm.id && iv.track_stock && iv.track_cogs === undefined) {
        return {
          ...iv,
          track_cogs: true
        }
      } else {
        return {
          ...iv
        }
      }
    })
    const newItem = {...itemForm, item_variants: itemVariantsWithTracking}
    yield put(initialize('modal_item_variants', newItem))
  } else {
    yield put(initialize('modal_item_variants', itemForm))
  }
}

export function * onCancelItemInventoryAlertModal (request) {
  yield put(initialize('modal_item_variants', {}))
  yield put(actItem.hideItemInventoryAlertModal())
}

export function * onCancelCOGSModal (request) {
  yield put(initialize('modal_item_variants', {}))
  yield put(actItem.hideCOGSModal())
}

export function * submitFormCreate (request) {
  const {payload: {values, items, allOutlet, search}} = request
  try {
    yield put(act.showProgressBar())
    yield put(actItem.setIsSubmittingForm(true))
    values.item.item_variants.forEach((iv, index) => {
      iv.position = index
    })
    let postItemRes
    let updatedItem
    if (allOutlet) {
      postItemRes = yield call(apiItem.postCreateAllOutletItem, values)
      const createdItems = JSON.parse(postItemRes.data.items)
      for (let i = 0; i < createdItems.length; i++) {
        const item = createdItems[i]
        if (item.outlet_id === search.outletIds[0]) {
          const updatedItemRes = yield call(apiItem.getItemById, item.id)
          updatedItem = updatedItemRes.data
          items.unshift(updatedItem)
        }
      }
    } else {
      postItemRes = yield call(apiItem.postItem, values)
      const updatedItemRes = yield call(apiItem.getItemById, postItemRes.data.id)
      updatedItem = updatedItemRes.data
      items.unshift(updatedItem)
    }
    updatedItem.item_variants.forEach((iv) => {
      iv.is_editable = !iv.is_saved
      iv.saved_cogs = !(iv.cogs === null && !iv.track_cogs)
    })
    yield put(initialize('item', updatedItem))
    if (allOutlet) {
      mpLibItem.libraryItemCreate({item: updatedItem, allOutlet: true})
    } else {
      mpLibItem.libraryItemCreate({item: updatedItem, allOutlet: false})
    }

    let query = {
      page: 1,
      category_id: !parseInt(search.categoryId) ? '' : search.categoryId,
      inventory: !parseInt(search.typeInventoryId) ? 'all' : (search.typeInventoryId === '1' ? 'low' : 'out'),
      keyword: !search.search ? '' : search.search
    }
    let summary = yield call(fetchSummary, query) // todo refactor
    yield put(actItem.setItemSummary(summary))

    yield put(actItem.setItems(items))
    yield put(actItem.setItemDetail(updatedItem))
    if (allOutlet) {
      if (postItemRes.data.is_async_perform) {
        yield put(actItem.showSaveToAllOutletsModal())
      } else {
        yield put(actNotif.success('Item was successfully created.'))
      }
    } else {
      yield put(actNotif.success('Item was successfully created.'))
    }
  } catch (error) {
    yield put(actNotif.error(error.message.includes('Custom Amount') ? 'Failed to create items' : error.message))
  } finally {
    yield put(actItem.setIsSubmittingForm(false))
    yield put(act.hideProgressBar())
  }
}

export function * submitFormUpdate (request) {
  const {payload: {itemId, values, items}} = request
  try {
    yield put(act.showProgressBar())
    yield put(actItem.setIsSubmittingForm(true))

    yield call(apiItem.updateImageById, itemId, {
      item: {
        remote_image_url: values.item.image.url,
        category_id: values.item.category.id
      }
    })
    values.item.item_variants.map((iv, index) => {
      if (!iv.track_cogs) {
        iv.cogs = null
      }
      iv.position = index
    })
    yield call(apiItem.putItemById, itemId, values)
    const updatedItemRes = yield call(apiItem.getItemById, itemId)
    const updatedItem = updatedItemRes.data
    items.forEach((item, index) => {
      if (updatedItem.id === item.id) {
        items[index] = {...updatedItem}
      }
    })
    updatedItem.item_variants.forEach((iv) => {
      iv.is_editable = !iv.is_saved
      iv.saved_cogs = !(iv.cogs === null && !iv.track_cogs)
    })
    yield put(initialize('item', updatedItem))
    mpLibItem.libraryItemUpdate({item: updatedItem})
    yield put(actItem.setItems(items))
    yield put(actItem.setItemDetail(updatedItem))
    yield put(actNotif.success('Item was successfully saved.'))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(actItem.setIsSubmittingForm(false))
    yield put(act.hideProgressBar())
  }
}

export function * onConfirmItemInventoryAlertModal (request) {
  const {value, itemForm} = request.payload
  const itemVarCopy = itemForm.item_variants
  yield put(arrayRemoveAll('item', 'item_variants'))
  for (let idx = 0; idx < value.item_variants.length; idx++) {
    if (value.item_variants[idx].track_cogs) {
      value.item_variants[idx].track_cogs = value.item_variants[idx].track_stock
      if (!value.item_variants[idx].saved_cogs && !value.item_variants[idx].track_cogs) {
        value.item_variants[idx].cogs = null
      }
    }
    yield put(arrayPush('item', 'item_variants', {...value.item_variants[idx], is_saved: isSaved(value.item_variants[idx], itemVarCopy[idx])}))
  }
  yield put(initialize('modal_item_variants', {}))
  yield put(actItem.hideItemInventoryAlertModal())
}

function isSaved (iv, civ) {
  return civ.is_saved || iv.track_stock
}

export function * onConfirmCOGSModal (request) {
  const {value, isTrack} = request.payload
  yield put(arrayRemoveAll('item', 'item_variants'))
  for (let idx = 0; idx < value.item_variants.length; idx++) {
    if (!value.item_variants[idx].saved_cogs && !value.item_variants[idx].track_cogs) {
      value.item_variants[idx].cogs = null
    }
    yield put(arrayPush('item', 'item_variants', value.item_variants[idx]))
  }
  mpLibItem.cogsTrackingItem({itemVariant: value.item_variants, cogsTrack: isTrack})
  yield put(initialize('modal_item_variants', {}))
  yield put(actItem.hideCOGSModal())
}

export function * deleteItem (request) {
  const {payload: {item, previousItems, search}} = request
  try {
    yield put(act.showProgressBar())
    // remove items
    let deletedIndex = -1
    previousItems.forEach((pitem, index) => {
      if (pitem.id === item.id) {
        deletedIndex = index
      }
    })
    if (deletedIndex !== -1) {
      previousItems.splice(deletedIndex, 1)
    }
    yield call(apiItem.deleteItemByIdV1, item.id)
    yield call(closeRightColumn)
    yield put(actItem.setItemDetail(null))
    yield put(reset('item'))
    yield put(actItem.hideDeleteModal())
    let query = {
      page: 1,
      category_id: !parseInt(search.categoryId) ? '' : search.categoryId,
      inventory: !parseInt(search.typeInventoryId) ? 'all' : (search.typeInventoryId === '1' ? 'low' : 'out'),
      keyword: !search.search ? '' : search.search
    }
    let summary = yield call(fetchSummary, query) // todo refactor
    yield put(actItem.setItemSummary(summary))
    yield put(actNotif.success('Item was successfully removed.'))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
  }
}

export function * onClickCreateCategory (request) {
  const {payload: {category, previousCategories, previousCategoryId}} = request
  yield put(actItem.setNewCategory(category))
  yield put(actItem.setPreviousCategories(previousCategories))
  // push new category since we want to 'manipulate' the view using redux,
  // using id == 0 as 'dummy id' for category
  const categories = [...previousCategories]
  categories.push({
    id: 0,
    name: category
  })
  yield put(actItem.setCategories(categories))
  yield put(actItem.setPreviousCategoryId(previousCategoryId))
  // wait to make the event dispatched successfully propagated
  yield call(delay, 50)
  yield put(change('item', 'category_id', 0))
  if (category) {
    yield put(actItem.showNewCategoryModal())
  }
}

export function * onClickCancelCreateCategory (request) {
  const {payload: {previousCategories, previousCategoryId}} = request
  yield put(actItem.setCategories(previousCategories))
  yield put(change('item', 'category_id', previousCategoryId))
  yield put(actItem.hideNewCategoryModal())
}

export function * onClickConfirmCreateCategory (request) {
  const {payload: {category}} = request
  try {
    yield put(act.showProgressBar())
    const createCategoryRes = yield call(apiCategory.createCategory, {name: category})
    const categoriesRes = yield call(apiCategory.getCategoriesWithUncategorizedV1)
    yield put(actItem.setCategories(categoriesRes.data))
    yield put(change('item', 'category_id', createCategoryRes.data.id))
    yield put(actNotif.success('Category successfully created.'))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(actItem.hideNewCategoryModal())
  }
}

export function * onSuccessImport () {
  yield put(actItem.hideImportModal())
  yield put(actItem.closeRightColumn())
  yield put(actNotif.success('Item successfully imported'))
  yield put(actItem.pageRequest())
}

export default function * libraryItemSaga () {
  yield takeLatest(LIBRARY_ITEM_SET_FILTER_ITEM, setFilterItem)
  yield takeLatest(LIBRARY_ITEM_PAGE_REQUEST, pageRequestFlow)
  yield takeLatest(LIBRARY_ITEM_ON_CHANGE_OUTLET_IDS, onChangeOutletIds)
  yield takeLatest(LIBRARY_ITEM_LIST_ITEM_REQUEST, itemsRequest)
  yield takeLatest(LIBRARY_ITEM_ITEM_LIST_EXPORT, getExportItem)
  yield takeLatest(LIBRARY_ITEM_ITEM_LIST_TEMPLATE, downloadItemsTemplate)
  yield takeLatest(LIBRARY_ITEM_ON_CLICK_CREATE_ITEM, clickCreateItem)
  yield takeLatest(LIBRARY_ITEM_ON_CLICK_CANCEL, clickCancel)
  yield takeLatest(LIBRARY_ITEM_ON_CLICK_ROW, clickItemRow)
  yield takeLatest(LIBRARY_ITEM_ON_CLICK_BTN_ITEM_VARIANT, onClickBtnItemVariant)
  yield takeLatest(LIBRARY_ITEM_ON_CANCEL_ITEM_VARIANT_MODAL, onCancelItemVariantModal)
  yield takeLatest(LIBRARY_ITEM_ON_CONFIRM_ITEM_VARIANT_MODAL, onConfirmItemVariantModal)
  yield takeLatest(LIBRARY_ITEM_ON_CLICK_BTN_ITEM_TRACKING, onClickBtnItemTracking)
  yield takeLatest(LIBRARY_ITEM_ON_CLICK_BTN_COGS_TRACKING, onClickBtnCOGSTracking)
  yield takeLatest(LIBRARY_ITEM_ON_CANCEL_ITEM_INVENTORY_ALERT_MODAL, onCancelItemInventoryAlertModal)
  yield takeLatest(LIBRARY_ITEM_ON_CANCEL_COGS_MODAL, onCancelCOGSModal)
  yield takeLatest(LIBRARY_ITEM_ON_CONFIRM_ITEM_INVENTORY_ALERT_MODAL, onConfirmItemInventoryAlertModal)
  yield takeLatest(LIBRARY_ITEM_ON_CONFIRM_COGS_MODAL, onConfirmCOGSModal)
  yield takeLatest(LIBRARY_ITEM_FILL_FORM_DETAIL_ITEM, fillFormDetail)
  yield fork(getCategoriesWithUncategorizedFlow)
  yield takeLatest(LIBRARY_ITEM_SUBMIT_FORM_CREATE, submitFormCreate)
  yield takeLatest(LIBRARY_ITEM_SUBMIT_FORM_UPDATE, submitFormUpdate)
  yield takeLatest(LIBRARY_ITEM_DELETE_ITEM, deleteItem)
  yield takeLatest(LIBRARY_ITEM_ON_CLICK_CREATE_NEW_CATEGORY, onClickCreateCategory)
  yield takeLatest(LIBRARY_ITEM_CONFIRM_CREATE_NEW_CATEGORY, onClickConfirmCreateCategory)
  yield takeLatest(LIBRARY_ITEM_CANCEL_CREATE_NEW_CATEGORY, onClickCancelCreateCategory)
  yield takeLatest(LIBRARY_ITEM_ON_SUCCESS_IMPORT, onSuccessImport)
}



// WEBPACK FOOTER //
// ./app/sagas/library/item.js